import CardLocation from "./card-locations";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/components/pagination/pagination.min.css";
import "swiper/components/navigation/navigation.min.css";
import SwiperCore, { Autoplay, Pagination, Navigation } from "swiper";
import "swiper/swiper.min.css";
import { laptop1600, Loadingspinner, instanceMob } from "../../../utils/utils";
import { Modal } from "react-bootstrap";
import moment from "moment";
import { getBackendError } from "../../../utils/error-helpers";
import { useState } from "react";

const Locations = (props) => {
  SwiperCore.use([Pagination, Autoplay, Navigation]);
  const modalAddLocation = props.modalAddLocation;
  const locations = props.locations;
  const cities = props.cities;
  const isLoading = props.isLoading;

  const [showLogsModal, setShowLogsModal] = useState(false);
  const [logs, setLogs] = useState([]);
  const [isLoadingLogs, setIsLoadingLogs] = useState(false);
  const [selectedLocationName, setSelectedLocationName] = useState("");

  const fetchLogs = async (locationId) => {
    setIsLoadingLogs(true);
    try {
      const res = await instanceMob.get(`/biometrics/customer/logs?location=${locationId}`);
      const logsData = res.data?.results || res.data || [];
      const mappedData = (Array.isArray(logsData) ? logsData : []).map(x => ({
        id: x.id,
        customer_name: x.customer_name || "N/A",
        location: x.location,
        is_allowed: x.is_allowed,
        date: x.access_date ? moment(x.access_date, "DD/MM/YYYY hh:mm:ss A").format("DD/MM/YYYY HH:mm") : "N/A",
        status: x.is_allowed ? "Permitido" : "Denegado"
      }));
      setLogs(mappedData);
    } catch (err) {
      console.error("Error fetching logs:", err);
      setLogs([]);
    } finally {
      setIsLoadingLogs(false);
    }
  };

  const handleViewLogs = (location) => {
    setSelectedLocationName(location.name);
    setShowLogsModal(true);
    fetchLogs(location.id);
  };

  return (
    <div className="d-flex h-100 justify-content-center  align-items-center flex-column">
      <div
        className="d-flex w-100"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0.5rem",
        }}
      >
        <div className="py-0" style={{ marginLeft: "40%" }}>
          <span
            style={{
              fontSize: "calc(.4rem + .4vw)",
              color: "var(--elevvaTextTitle)",
            }}
          >
            Locaciones de <strong>entrenamiento</strong>{" "}
          </span>
        </div>
        <button
          style={{ marginRight: "2%" }}
          className="  d-flex add_location"
          onClick={modalAddLocation}
        >
          Agregar locación +
        </button>
      </div>
      {isLoading ? (
        <Loadingspinner customStyle="grow" size="2.5rem" />
      ) : (
        <>
          {locations.length > 0 ? (
            <div
              className="position-relative w-100 h-100"
              style={{
                width: "95%",
                overflow: "hidden",
                margin: "auto",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                className={
                  "d-flex position-absolute  w-100 h-100 swiper-pagination_p"
                }
              >
                <div
                  style={{ zIndex: 10 }}
                  className={`button-prev-exercise-${`location`} swiper-button-prev-exercise`}
                ></div>
                <div
                  className={`button-next-exercise-${`location`} swiper-button-next-exercise`}
                  style={{
                    zIndex: 10,
                    left: laptop1600.matches ? "90%" : "88%",
                    transform: "translateX(-50%)",
                  }}
                ></div>
              </div>
              <Swiper
                style={{ width: "80%", padding: "1rem 0", height: "100%" }}
                id={`swiper-company-${`location`}`}
                keyboard={{
                  enabled: true,
                }}
                slidesPerView={"auto"}
                navigation={{
                  nextEl: `.button-next-exercise-${`location`}`,
                  prevEl: `.button-prev-exercise-${`location`}`,
                }}
                modules={[Navigation]}
              >
                {locations.length > 0 &&
                  locations.map((location) => (
                    <SwiperSlide
                      className="d-flex position-relative  flex-column w-auto  mx-2 h-100 "
                      key={location.id}
                    >
                      {" "}
                      <CardLocation
                        location={location}
                        cities={cities}
                        deleteLocation={props.deleteLocation}
                        editLocation={props.editLocation}
                        viewLogs={handleViewLogs}
                      />
                    </SwiperSlide>
                  ))}
              </Swiper>
            </div>
          ) : (
            <div className="d-flex w-100 h-100 justify-content-center align-items-center">
              <span
                style={{
                  fontSize: "calc(.4rem + .4vw)",
                  color: "var(--elevvaTextTitle)",
                }}
              >
                No hay locaciones de entrenamiento
              </span>
            </div>
          )}
        </>
      )}

      {/* Modal for Logs */}
      <Modal
        show={showLogsModal}
        onHide={() => setShowLogsModal(false)}
        centered
        size="lg"
        className="biometric-logs-modal"
      >
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="fs-6 fw-bold">
            Logs de Acceso - {selectedLocationName || "Locación"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          {isLoadingLogs ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary mb-3" role="status"></div>
              <p className="text-muted mb-0">Cargando logs...</p>
            </div>
          ) : logs.length > 0 ? (
            <div className="table-responsive" style={{ maxHeight: '400px', overflowY: 'auto' }}>
              <table className="table table-hover">
                <thead className="table-light" style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                  <tr>
                    <th>Fecha</th>
                    <th>Usuario</th>
                    <th>Ubicación</th>
                    <th>Estado</th>
                  </tr>
                </thead>
                <tbody>
                  {logs.map(log => (
                    <tr key={log.id}>
                      <td className="small">{log.date}</td>
                      <td className="small">{log.customer_name}</td>
                      <td className="small">{log.location || "N/A"}</td>
                      <td>
                        <span className={`badge ${log.is_allowed ? 'bg-success' : 'bg-danger'}`}>
                          {log.status}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="text-center py-5">
              <i className="bi bi-inbox fs-1 text-muted mb-3 d-block"></i>
              <p className="text-muted mb-0">No hay logs disponibles para esta locación.</p>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Locations;
